export const PAYMENT_PLAN = "PAYMENT_PLAN"
export const DEBT_RECOVERY = "DEBT_RECOVERY"
